module.exports = __webpack_public_path__ + "img/do-powtorzenia.9b019866.png";